let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4IXyQ")).then(() => parcelRequire('6b5RU'));